var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeach = function SvgPeach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#peach_svg__a)",
    d: "M109.665 195.671s-15.181 4.034-28.758-16.145c-22.246-33.061-14.156-98.181 31.346-110.2 25.868-6.834 33.937 14.865 48.495 18.619s-9.685 78.286-51.083 107.726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#peach_svg__b)",
    d: "M163.326 88.884c7.13 2.785 13.4.782 21.124 6 14.171 9.573 25.246 32.048 7.041 69-24.141 49-68.4 39-81.477 33s-18.386-40.609-6.035-68c13.077-29 31.182-51 59.347-40"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "peach_svg__a",
    x1: 97.128,
    x2: 149.525,
    y1: 188.576,
    y2: 78.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#A1CEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#5CABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#2B91BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0D81B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peach_svg__b",
    x1: 136.624,
    x2: 167.149,
    y1: 202.232,
    y2: 86.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B89BB"
  })))));
};
export default SvgPeach;